import { renderBlockIcon } from 'minecraft-inventory/src/cache/blockRenderer'
import { resolveItemTextures } from '../react/inventory/sharedConnectorSetup'
import { inventoryBundledConfig } from '../react/inventory/inventoryTexturesConfig'
import type { XRInventoryAssets } from './xrInventoryCanvas'

/** Production sprites use exactly the desktop inventory's resource-pack-aware resolver. */
export const xrItemAssets: XRInventoryAssets = {
  guiTexture: path => inventoryBundledConfig.getGuiTextureUrl(path),
  async itemTexture(item) {
    const resolved = resolveItemTextures(item)
    if (resolved.texture) return resolved.texture
    if (!resolved.blockTexture) return null
    const block = resolved.blockTexture
    return renderBlockIcon(block.source, block.top.slice, block.left.slice, block.right.slice)
  },
}
